import FieldDropdown from "../../../../fields3/generic/dropdown/dropdown"

import getExistingUserAccessOptions from "./user-access-options"
import FieldConfig from "../../../../fields3/proto/field-config"
import {
    ProjectAccess,
    ProjectAccessDescriptionDictionary,
    ProjectAccessLabelDictionary, WorkspaceAccessDescription
} from "../../../../gd/const/project"

export default class FieldWorkspaceAccess extends FieldDropdown {

    public minAccess?: ProjectAccess

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Workspace Access";
        // this.typeGroup          = GROUP_INFO

        this.noValueOption      = false;

        this.options            = _.get(config, 'options', [
            {
                value       : ProjectAccess.FULL,
                label       : ProjectAccessLabelDictionary[ProjectAccess.FULL],
                description : WorkspaceAccessDescription[ProjectAccess.FULL]},
            {
                value       : ProjectAccess.STANDARD,
                label       : ProjectAccessLabelDictionary[ProjectAccess.STANDARD],
                description : WorkspaceAccessDescription[ProjectAccess.STANDARD]},
            // {value: ProjectAccess.LIMITED,      label: ProjectAccessLabelDictionary[ProjectAccess.LIMITED],     description: ProjectAccessDescriptionDictionary[ProjectAccess.LIMITED]},

            // {value: ProjectAccess.CLIENT,       label: ProjectAccessLabelDictionary[ProjectAccess.CLIENT],      description: ProjectAccessDescriptionDictionary[ProjectAccess.CLIENT],     notSelectable: true},
            // {value: ProjectAccess.READ_ONLY,    label: ProjectAccessLabelDictionary[ProjectAccess.READ_ONLY],   description: ProjectAccessDescriptionDictionary[ProjectAccess.READ_ONLY]},
        ])

        this.minAccess          = _.get(config, 'minAccess', undefined)

        this.classes.PopoverMenu = 'max-w-250'
        this.classes.PopoverMenuScrollContainer = 'max-h-400'

        this.components.PopoverMenuMore = null
    }

    getOptionsForEdit(model:any) {
        const editOptions = _.clone(this.options)

        _.map(editOptions, (option:Option)=>{
            option.disabled = (this.minAccess && option.value < this.minAccess)
        })

        return editOptions || []
    }

    // /*** DATA FUNCTIONS ***/
    // _updateOptions(model) {
    //     const availableAccesses = getExistingUserAccessOptions(model[this.fieldId], model.projectUser, model.projectUsers);
    //
    //     _.map(this.options, option=>{
    //         option.disabled = !availableAccesses.includes(option.value);
    //     })
    // }

    sortValue(value:any) {
        return value ? value : 0;
    }

    // /*** Base Render methods ***/
    //
    // renderInlineEditable(model, onChange) {
    //     // model projectUser and projectUsers required for determine disabled access options
    //     // if not set then all access options available
    //     this._updateOptions(model);
    //
    //     return super.renderInlineEditable(model, onChange);
    // }

}